<template>
    <v-form>
        <v-row>
            <v-col sm="12" md="6">
                <v-text-field
                    label="Key"
                    v-model="setting.key"
                    :error="errors.hasOwnProperty('key')"
                    :error-messages="errors.hasOwnProperty('key') ? errors.key : ''"
                >
                </v-text-field>
            </v-col>
            <v-col sm="12" md="6">
                <v-text-field
                    label="Value"
                    v-model="setting.value"
                    :error="errors.hasOwnProperty('value')"
                    :error-messages="errors.hasOwnProperty('value') ? errors.value : ''"
                ></v-text-field>
            </v-col>
        </v-row>        
        <v-row>
            <v-col>
                <v-btn
                    color="orange"
                    large
                    value="Save"
                    @click="handleSave"
                >
                    <span>{{ $t('Save') }}</span>
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>

import TextEditor from "@/components/app/form/TextEditor";
export default {
    name: "FromRequest",
    props: ['settingData', 'errors'],
    components: {
        TextEditor,
    },
    data: function () {
        return {
            setting: {
                key: '',
                value: '',
                status: 1,
            },
        }
    },
    watch: {
        settingData() {
            this.setSetting()
        },
    },
    methods: {
        handleSave() {
            this.$emit('submit', this.setting)
        },
        setSetting() {
            if (!this.settingData) {
                return
            }
            this.setting = Object.assign(this.setting, this.settingData)
        }
    },
    created() {
        this.setSetting()
    }
}
</script>

<style lang="scss">
</style>
